@use "sass:math";
@import "~/styles/v1/_variables.scss";
@import "~/styles/v1/_spacing.scss";
@import "~/styles/v1/_animation.scss";

.Table {
  @include border-standard;
  background: $system_white-lightest;
  border-bottom: 0;
  overflow: hidden;
  overflow-x: auto;

  &_square {
    border-radius: 0;

    .Header,
    .Footer {
      border-radius: 0;
    }
  }

  &_flush {
    border: 0;
  }

  &_empty {
    border-bottom: $border-standard;
  }
}

.Header,
.Footer {
  background: var(--v5-table-bg, $system_gray-lighter);
  color: $system_eggplant-lighter;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;

  .Cell {
    background: var(--v5-table-bg, $system_gray-lighter);
    display: flex;
    padding-bottom: math.div($size-M, 2);
    padding-top: math.div($size-M, 2);

    // SORTING
    &:hover {
      .SortIcon:not(.SortIcon_active) {
        opacity: 0.45;
      }
    }
  }

  // SORTING
  .SortIcon {
    margin-left: 5px;
    margin-top: -2px;
    opacity: 0;

    &.SortIcon_active {
      opacity: 1;
    }
  }

  // ORDERING
  .Handle {
    img {
      margin-bottom: -4px;
      margin-top: 0;
    }
  }
}

.Footer {
  border-bottom: $border-standard;
  left: 0;
  position: sticky;
}

.Post {
  text-align: center;
}

.Body {
  .Row {
    &.no_padding .Cell {
      padding: 0;
    }

    &.S .Cell {
      padding-bottom: $size-XS;
      padding-top: $size-XS;
    }
    &.L .Cell {
      padding-bottom: $size-M;
      padding-top: $size-M;
    }

    .Cell {
      border-bottom: $border-standard;
      transition: background 0.3s;

      &_editable:hover {
        background: $system_white-lighter;
        cursor: pointer;
      }

      &_rowspan {
        border-bottom: 0;
      }

      &.no_padding {
        padding: 0;
      }

      &.S {
        padding-bottom: $size-XS;
        padding-top: $size-XS;
      }

      &.M {
        padding-bottom: $size-S;
        padding-top: $size-S;
      }

      &.L {
        padding-bottom: $size-M;
        padding-top: $size-M;
      }
    }

    // EXPANSION
    .ExpansionCell {
      padding-right: 0;

      .ExpanderIcon {
        margin-top: 3px;
        vertical-align: initial;
      }
    }

    // SELECTION
    .SelectionCell {
      padding-right: 0;
    }
    .SelectionCheckbox {
      margin-top: 1px;
    }
  }

  .Add {
    .Cell {
      border-bottom: 0;
    }

    .AddIcon {
      margin-top: 2px;
    }

    .AddText {
      font-weight: 600;
    }
  }
}

.Cell {
  padding: $size-S;
  z-index: 1;

  &:last-of-type {
    border-right: 0;
  }

  &_bordered:not(:last-of-type) {
    border-right: $border-standard;
  }

  &_sticky {
    background: $system_white-lightest;
    position: sticky;
    z-index: 2;

    &_last {
      border-right: $border-standard !important;
      box-shadow: 2px 0 0 rgba(0, 0, 0, 0.06);
    }
  }

  &.align_C {
    display: flex;
    justify-content: center;
  }

  &.align_R {
    display: flex;
    justify-content: flex-end;
  }

  &.valign_C {
    display: flex;
    align-items: center;
  }

  &.valign_B {
    display: flex;
    align-items: flex-end;
  }

  > div {
    width: 100%;
  }
}

.Add {
  display: flex;

  .AddWrapper {
    left: 0;
    position: sticky;
    width: 100%;
  }

  &.Row {
    border-bottom: $border-standard;
  }

  .AddIcon {
    margin: 0 5px 0 0;
    vertical-align: top;
  }

  .AddText {
    color: $system_eggplant-lightest;
    opacity: 0;
    transition: 0.3s;
  }

  &:hover .AddText {
    opacity: 1;
  }
}

// Borders

.Table_bordered {
  .Cell {
    border-right: $border-standard;

    &_noborder,
    &:last-of-type,
    &.OrderingCell,
    &.ExpansionCell,
    &.SelectionCell {
      border-right: 0;
    }

    &_noborder.GroupCell {
      border-right: 1px solid transparent;
    }
  }
}

// Loading

@keyframes loadingShimmer {
  0% {
    width: 30px;
  }
  100% {
    width: 100%;
  }
}

.LoadingBar {
  height: 10px;
  margin-top: 4px;
  max-width: 60%;
  width: 90px;

  .LoadingBar_inner {
    animation-direction: alternate;
    animation-duration: 0.8s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: loadingShimmer;
    animation-timing-function: ease-in-out;
    background: var(--v5-table-bg, $system_gray-lighter);
    border-radius: 20px;
    height: 100%;
  }
}

// GROUPING

.Group_expandable {
  margin-right: 7px;
}

.GroupExpandIcon {
  transition: transform $animation_duration-fast;
}

// EXPANSION

.ExpanderIcon {
  transition: transform $animation_duration-fast;
}

// INDEXING

.IndexCell {
  padding-top: 2px;
}

// ORDERING

.OrderingCell {
  padding-right: 0;
}

.Handle {
  cursor: grab;
  opacity: 0.2;

  img {
    margin-bottom: -1px;
    margin-top: 1px;
    vertical-align: initial;
  }
}

.ghostClass {
  background: $system_white-base;

  > * {
    opacity: 0;
  }
}

.dragClass {
  background: $system_white-lightest;
  border-color: transparent;
}
